import PropTypes from 'prop-types';
import { Input, Tooltip } from 'antd';
import NumberFormat from 'react-number-format';

import { BaseComponent } from 'src/components';

class CellInputExpenses extends BaseComponent {
  constructor(props) {
    super(props)

    this.initState({
      isEditing: false,
      // value: props.value,
    })
  }

  blur = () => {
    this.setState({ isEditing: false })
  }

  onSave = (value) => {
    this.blur()
    this.props.onSave(value)
  }

  renderLabel() {
    return (
      <div style={{ cursor: 'pointer' }} onClick={() => this.setState({ isEditing: true })}>
        <NumberFormat
          thousandSeparator
          displayType='text'
          value={this.props.value || '-'}
        />
      </div>
    )
  }

  renderInput() {
    return (
      <Tooltip
        color="#1890ff"
        // placement="right"
        trigger={['focus']}
        title="Press enter to confirm"
      >
        <Input
          autoFocus
          bordered={false}
          size="small"
          defaultValue={this.props.value || ''}
          style={{ padding: 0, textAlign: 'right' }}
          onBlur={this.blur}
          onKeyDown={e => e.key === 'Escape' && this.blur()}
          onPressEnter={(e) => this.onSave(e.target.value)}
        />
      </Tooltip>
    )
  }

  render() {
    return (
      <div>
        {this.state.isEditing
          ? this.renderInput()
          : this.renderLabel()}
      </div>
    )
  }
}

CellInputExpenses.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onSave: PropTypes.func.isRequired,
}

export default CellInputExpenses